<script setup lang="ts">
    import { useI18n } from 'vue-i18n';
    import Corpay from '../icons/Corpay.vue';
    import KeepersSmall from '../icons/KeepersSmall.vue';
    import Marquee from '../Marquee.vue';
    import { computed } from 'vue';
    import type { Company } from '@/types';

    const props = defineProps<{
        company: Company;
    }>();

    const { t } = useI18n();

    const items = computed(() => {
        const list = [];

        if (props.company.keepers_email) {
            list.push({
                icon: KeepersSmall,
                title: t('companies.form.keepers_email'),
                email: props.company.keepers_email,
            });
        }

        if (props.company.roger_invoices) {
            list.push({
                icon: Corpay,
                title: t('companies.form.roger_invoices'),
                email: props.company.roger_invoices,
            });
        }

        if (props.company.roger_receipts) {
            list.push({
                icon: Corpay,
                title: t('companies.form.roger_receipts'),
                email: props.company.roger_receipts,
            });
        }

        return list;
    });
</script>

<template>
    <div class="w-full overflow-hidden">
        <Marquee
            :gradient="true"
            :gradient-color="[255, 255, 255]"
            gradient-length="5%"
            pause-on-hover
            clone
        >
            <div
                v-for="item in items"
                :key="item.title"
                class="flex flex-col gap-1 px-5"
            >
                <div class="flex items-center gap-1">
                    <component
                        :is="item.icon"
                        className="size-4"
                    />
                    <span class="text-xs font-bold">{{ item.title }}</span>
                </div>
                <a
                    :href="`mailto:${item.email}`"
                    class="text-secondary text-xs hover:underline"
                >
                    {{ item.email }}
                </a>
            </div>
        </Marquee>
    </div>
</template>
